import { gql } from '@apollo/client';
import { FIND_CACHE_FRAGMENT } from './getMyFindsQuery';

export const CommitSmartImportMutationName = 'CommitSmartImport';

export const COMMIT_SMART_IMPORT_MUTATION = gql`
  mutation ${CommitSmartImportMutationName}($id: ID!) {
    commitSmartImport(id: $id) {
      smartImport {
        id
        status
        completedAt
        committedFindIds
      }
      createdFindCount
      createdFindIds
      createdFinds {
        ...FindCacheFields
      }
    }
  }
  ${FIND_CACHE_FRAGMENT}
`;
